import {WorkEntityKind} from "src/app/enums/WorkEntityKind.enum";
import {WorksTypes} from "src/app/enums/Works.enum";
import {PEOPLE_TYPE_LABELS} from "src/app/modules/shared/constants/people-type-labels.constants";
import {WorkEntitySuggestion} from "src/app/modules/shared/interfaces/WorkEntitySuggestion.interface";

const SERIES_LABELS: Record<WorksTypes, string> = {
  [WorksTypes.Movie]: "CATALOG_SEARCH_FILM_SERIES",
  [WorksTypes.Series]: "CATALOG_SEARCH_TV_SERIES",
  [WorksTypes.Animation]: "CATALOG_SEARCH_TV_SERIES",
  [WorksTypes.Game]: "CATALOG_SEARCH_GAME_SERIES",
  [WorksTypes.Manga]: "CATALOG_SEARCH_MANGA_SERIES",
  [WorksTypes.Comic]: "CATALOG_SEARCH_COMIC_SERIES",
  [WorksTypes.Book]: "CATALOG_SEARCH_BOOK_SERIES",
};

export function getEntityRoleLabelKey(
  entity: WorkEntitySuggestion,
  compact = false
): string {
  if (entity.peopleType) return PEOPLE_TYPE_LABELS[entity.peopleType];
  if (entity.kind === WorkEntityKind.Company) return "CATALOG_SEARCH_STUDIO";
  if (entity.kind === WorkEntityKind.Series) {
    if (compact && entity.type === WorksTypes.Game)
      return "CATALOG_SEARCH_GAME_SERIES_SHORT";
    return entity.type
      ? SERIES_LABELS[entity.type]
      : "CATALOG_SEARCH_COLLECTION";
  }
  if (entity.kind === WorkEntityKind.Franchise)
    return "CATALOG_SEARCH_FRANCHISE";
  return "CATALOG_SEARCH_PERSON";
}

export function getEntityScopeLabelKey(
  entity: WorkEntitySuggestion
): string | null {
  return entity.kind === WorkEntityKind.Franchise
    ? "CATALOG_SEARCH_SCOPE_ALL_MEDIA"
    : null;
}
